import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

// Casca do atendimento em telas estreitas: faixa de navegação (48px) + conteúdo.
// Tela cheia, sem moldura — desconta só a barra superior compacta (56px) do layout.
const TicketAdvancedLayout = styled(Paper)({
    height: `calc(100% - 56px)`,
    display: "grid",
    gridTemplateRows: "48px minmax(0, 1fr)",
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
    overflow: "hidden",
})

export default TicketAdvancedLayout;
